import React, { Component } from 'react';


class AppFooter extends Component {
    render() {
        return (
        <footer id="footer">
                    For support, please contact your agency's security staff.
            </footer>
        )
    }
}

export default AppFooter;